module.exports = __webpack_public_path__ + "static/data-management-6f53a09ad5dfb552cb44319891ea7f71.png";